import React, { useState, useEffect } from "react";
import Pagination from "../../../../components/global/pagination/Pagination.jsx";
import columns from "../../../../columns/wallet/Withdraw/pending.js";
import ModalComponent from "../../../../components/global/modal/ModalComponent.jsx";
import TableWithSkeleton from "../../../../components/global/table/TableWithSkeleton.jsx";
import ConfirmationModal from "../../../../components/global/modal/ConfirmationModal.jsx";
import Eye from "../../../../assets/Eye.jsx";
import { GetAllAccountApi, RequestAcceptRejectApi } from "../../../../api/request/wallet/withdraw.js";
import moment from "moment";
import toast from "react-hot-toast";
import Copytest from "../../../../components/copy/Copy.jsx"
import Copy from '../../../../components/copy/Copy.jsx';
import { Form, Input } from "antd";
import LoadableButton from "../../../../components/buttons/LoadableButton.jsx";
import useModulePermissions from "../../../../hooks/useModulePermissions.jsx";

const { TextArea } = Input;

export default function Withdraw({ search, dates, onSummaryChange }) {

    const withdrawPermissions = useModulePermissions('wallet', 'withdraw');
    const canAcceptReject = !!withdrawPermissions.accept_reject;

    const [form] = Form.useForm();

    const [pageSize, setPageSize] = useState(10);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [requestRejection, setrequestRejection] = useState(false);
    const [requestAccept, setrequestAccept] = useState(false);
    const [totalRecord, setTotalRecord] = useState(0);
    const [selectedIBId, setSelectedIBId] = useState(null)
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [isReqLoading, setIsReqLoading] = useState(false);
    const [textAreaValue, setTextAreaValue] = useState('');
    const [withdrawdetails, setWithdrawdetails] = useState({});
    const [acceptTarget, setAcceptTarget] = useState(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [sorter, setSorter] = useState({ SortBy: 'requestDate', SortOrder: '' });

    const getWithdrawChargeSummary = (item) => {
        const requested = Number(item?.amount) || 0;
        const percent = Number(item?.fee) || 0;
        const storedNet = Number(item?.amountTopay ?? item?.amountToPay);
        const hasStoredNet =
            item?.amountTopay !== undefined &&
            item?.amountTopay !== null &&
            item?.amountTopay !== "" &&
            !(storedNet === 0 && percent === 0 && requested > 0);
        let net = hasStoredNet ? storedNet : requested;
        if (percent > 0 && Math.abs(net - requested) < 0.001) {
            net = Math.round((requested - (requested * percent) / 100) * 100) / 100;
        }
        const safeNet = Number.isFinite(net) ? net : requested;
        const chargeAmount = Math.max(0, Math.round((requested - safeNet) * 100) / 100);
        return {
            requested,
            net: safeNet,
            chargeText: percent > 0 ? `${percent}% ($${chargeAmount.toFixed(2)})` : `$${chargeAmount.toFixed(2)}`,
            netText: `$${safeNet.toFixed(2)}`,
        };
    };

    const truncateString = (str) => {
        let string = str?.toString();
        return string?.substring(0, 6) + '...';
    };

    const handleClick = (item) => {
        setSelectedIBId({ userId: item?.userId, TransactionId: item?.requestId });
        setIsOpenModal(true);
    };

    const Withdrawrequest = (item) => {
        setSelectedRowKeys([item?.requestId]);
        setAcceptTarget(item);
        form.setFieldsValue({ amount: getWithdrawChargeSummary(item).net });
        setrequestAccept(true);
    };

    const WithdrawrequestReject = (item) => {
        setSelectedRowKeys([item?.requestId]);
        setrequestRejection(true);
    };

    const getAllWithdraw = async () => {
        try {
            let params = {
                PageNumber: page,
                PageSize: pageSize,
                SearchText: search,
                FilterText: "pending",
                FromDate: dates.length === 2 ? dates[0].format('MM-DD-YYYY') : '',
                ToDate: dates.length === 2 ? dates[1].format('MM-DD-YYYY') : '',
                ...sorter
            }
            setIsLoading(true);
            const { data } = await GetAllAccountApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setData(
                    data?.data?.map((item) => {
                        return {
                            ...item,
                            key: item?.requestId,
                            name: `${item?.firstName} ${item?.lastName}`,
                            balance: `$ ${item?.balance}`,
                            grossAmount: item?.amount,
                            netAmount: getWithdrawChargeSummary(item).net,
                            amount: `$ ${item?.amount}`,
                            fee: getWithdrawChargeSummary(item).chargeText,
                            amountTopay: getWithdrawChargeSummary(item).netText,
                            requestDate: moment(item?.requestDate).format('DD-MM-YYYY, hh:mm A'),
                            actionDate: moment(item?.actionDate).format('DD-MM-YYYY, hh:mm A'),
                            actions: (
                                <div className="flex">
                                    <button type="button" onClick={() => { setWithdrawdetails(item); handleClick(item); }}><Eye /></button>
                                    <button
                                        disabled={item?.ispartiallyapproved}
                                        className={`mr-3 ml-3 ${item?.ispartiallyapproved ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
                                        onClick={() => Withdrawrequest(item)}
                                    >
                                        <img src="assets/icons/accept_icon.svg" className="min-w-6 max-w-6" alt="icon" />
                                    </button>

                                    <button
                                        disabled={item?.ispartiallyapproved}
                                        className={`${item?.ispartiallyapproved ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
                                        onClick={() => WithdrawrequestReject(item)}
                                    >
                                        <img src="assets/icons/delete_icon.svg" className="min-w-6 max-w-6" alt="icon" />
                                    </button>
                                </div>
                            ),
                            address: (
                                <div className="flex">

                                    <p>{truncateString(item?.thirdPartyWalletAddress)}</p>
                                    <Copytest text={item?.thirdPartyWalletAddress} />

                                </div>
                            )

                        };
                    })
                );
                setTotalRecord(data?.totalRecords);
                onSummaryChange?.({
                    totalRecords: data?.totalRecords || 0,
                    totalWithdrawal: data?.totalWithdrawal || 0,
                });
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    }

    const RequestHandlerApproved = async (value) => {
        try {
            setIsReqLoading(true);
            let params = {
                ...(value?.amount && { amount: Number(value?.amount) }),
                WithdrawalRequestId: selectedRowKeys,
                IsApprovedRejected: true,
                comment: value?.comment,
            }
            const { data } = await RequestAcceptRejectApi(params);
            if (data?.success) {
                toast.success(data?.message);
                setSelectedRowKeys([])
            }
            getAllWithdraw();
            setTextAreaValue('');
            setIsReqLoading(false);
        } catch (error) {
            toast.error(error?.response?.data?.error?.message);
            setIsReqLoading(false);
        }
        setrequestAccept(false);
    }

    const RequestHandlerReject = async (value) => {
        if (!value) {
            if (!textAreaValue) {
                toast.error('Please enter a reason.');
                return;
            }
        }
        try {
            setIsReqLoading(true);
            let params = {
                WithdrawalRequestId: selectedRowKeys,
                IsApprovedRejected: false,
                comment: textAreaValue,
            }
            const { data } = await RequestAcceptRejectApi(params);
            if (data?.success) {
                toast.success(data?.message);
                setSelectedRowKeys([])
            }
            getAllWithdraw();
            setTextAreaValue('');
            setIsReqLoading(false);
        } catch (error) {
            toast.error(error?.response?.data?.error?.message);
            setIsReqLoading(false);
        }
        setrequestRejection(false);
    }

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter?.order) {
            setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
        } else {
            setSorter({ SortBy: 'requestDate', SortOrder: '' });
        }
    };

    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    useEffect(() => {
        if (!requestAccept) form.resetFields();
    }, [requestAccept]);

    useEffect(() => {
        getAllWithdraw();
    }, [page, pageSize, dates, search, sorter]);

    useEffect(() => {
        setPage(1);
    }, [search]);

    return (
        <div>
            <div className="flex flex-col gap-5">
                {selectedRowKeys.length > 1 && canAcceptReject ? (
                    <div className="flex justify-end px-4 lg:px-6">
                        <div className="flex justify-center items-center gap-3">
                            <button
                                className="bg-[#2D9B6333] text-sm text-[#2D9B63] font-semibold px-4 py-2 rounded-lg uppercase hover:bg-[#2D9B63] hover:text-white duration-500"
                                onClick={() => setrequestAccept(true)}
                            >
                                Accept
                            </button>
                            <button
                                className="bg-[#F8222333] text-sm text-[#F82223] font-semibold px-4 py-2 rounded-lg uppercase hover:bg-[#F82223] hover:text-white duration-500"
                                onClick={() => setrequestRejection(true)}
                            >
                                Reject
                            </button>
                        </div>
                    </div>
                ) : null}

                <div>
                    <TableWithSkeleton
                        columns={columns}
                        data={data}
                        rowSelection={canAcceptReject ? rowSelection : null}
                        loading={isLoading} onChange={handleTableChange}
                        hiddenColumns={!canAcceptReject ? ["Actions"] : []}
                        page={page}
                        pageSize={pageSize}
                        index={true}
                    />
                    <Pagination total={totalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
                </div>
            </div>

            {/* ---- Withdraw Information ---- */}
            <ModalComponent
                isOpen={isOpenModal}
                setIsOpen={setIsOpenModal}
                title='Withdraw Information'
                width={1300}
            >
                <div className='p-5'>
                    <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10 '>
                        {withdrawdetails?.firstName ? <div>
                            <p className='text-description font-normal'>First Name</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.firstName || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.lastName ? <div>
                            <p className='text-description font-normal'>Last Name</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.lastName || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.email ? <div>
                            <p className='text-description font-normal'>Email</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.email || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.withdrawType ? <div>
                            <p className='text-description font-normal'>withdraw Type</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.withdrawType || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.walletAccountNo ? <div>
                            <p className='text-description font-normal'>Wallet Account No.</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.walletAccountNo || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.bankAccountNumber ? <div>
                            <p className='text-description font-normal'>Bank Account Number</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.bankAccountNumber || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.balance ? <div>
                            <p className='text-description font-normal'>Wallet Balance</p>
                            <p className='text-description primary font-semibold mt-2'>$ {withdrawdetails?.balance || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.amount ? <div>
                            <p className='text-description font-normal'>Requested amount (wallet debit)</p>
                            <p className='text-description primary font-semibold mt-2'>$ {withdrawdetails?.amount || '---'}</p>
                        </div> : ""}
                        <div>
                            <p className='text-description font-normal'>Charge</p>
                            <p className='text-description primary font-semibold mt-2'>{getWithdrawChargeSummary(withdrawdetails).chargeText}</p>
                        </div>
                        <div>
                            <p className='text-description font-normal'>Net (client receives)</p>
                            <p className='text-description primary font-semibold mt-2'>{getWithdrawChargeSummary(withdrawdetails).netText}</p>
                        </div>
                        {withdrawdetails?.requestDate ? <div>
                            <p className='text-description font-normal'>Created Time</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.requestDate ? moment(withdrawdetails?.requestDate).format('DD-MM-YYYY, hh:mm A') : '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.bankBranchAddress ? <div>
                            <p className='text-description font-normal'>Bank Branch Address</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.bankBranchAddress || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.bankName ? <div>
                            <p className='text-description font-normal'>Bank Name</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.bankName || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.iban ? <div>
                            <p className='text-description font-normal'>IBAN</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.iban || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.ifscCode ? <div>
                            <p className='text-description font-normal'>IFSC Code</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.ifscCode || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.swifT_BIC_Code ? <div>
                            <p className='text-description font-normal'>SwifT BIC Code</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.swifT_BIC_Code || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.cryptoWalletAddress ? <div>
                            <p className='text-description font-normal'>Crypto Wallet Address</p>
                            <div className="flex items-center gap-3">
                                <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.cryptoWalletAddress || '---'}</p>
                                <Copy text={withdrawdetails?.cryptoWalletAddress} />
                            </div>
                        </div> : ""}
                        {withdrawdetails?.paypalEmail ? <div>
                            <p className='text-description font-normal'>Paypal Email</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.paypalEmail || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.upiId ? <div>
                            <p className='text-description font-normal'>UPI Id</p>
                            <div className="flex items-center gap-3">
                                <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.upiId || '---'}</p>
                                <Copy text={withdrawdetails?.upiId} />
                            </div>
                        </div> : ""}

                    </div>
                </div>
            </ModalComponent>

            {/* ---- Reject-request ---- */}
            <ConfirmationModal
                isOpen={requestRejection}
                setIsOpen={setrequestRejection}
                message='Are you sure you want to reject this request?'
                onConfirm={() => RequestHandlerReject(true)}
                isLoading={isReqLoading}
                loadingLabel='Rejecting request...'
                textArea={true}
                textAreaValue={textAreaValue}
                setTextAreaValue={setTextAreaValue}
                placeholder='Reason of rejection...'
            />

            {/* ---- Accept-request ---- */}
            <ModalComponent isOpen={requestAccept} setIsOpen={setrequestAccept} title="Accept withdraw request" width={500}>
                <>
                    <Form className='w-full' autoComplete="off" form={form} onFinish={RequestHandlerApproved}>
                        {selectedRowKeys.length <= 1 && acceptTarget && (
                            <div className="mb-4 text-sm text-[#2F2B3DCC] space-y-1">
                                <p>Requested amount (wallet debit): $ {getWithdrawChargeSummary(acceptTarget).requested.toFixed(2)}</p>
                                <p>Charge: {getWithdrawChargeSummary(acceptTarget).chargeText}</p>
                                <p>Net (client receives): {getWithdrawChargeSummary(acceptTarget).netText}</p>
                            </div>
                        )}
                        {selectedRowKeys.length <= 1 && <div className="input-white">
                            <label className="text-description text-[#2F2B3DCC] font-medium">Amount the client receives</label>
                            <Form.Item name="amount" rules={[{ required: true, message: 'Please enter amount.' }]}>
                                <Input type='number' placeholder="amount" className="mt-1 w-full ps-4 py-2" />
                            </Form.Item>
                        </div>}
                        <div className='input-white w-full mt-4'>
                            <label className='text-description text-[#2F2B3DCC] font-medium mb-2'>Comment</label>
                            <Form.Item name="comment" >
                                <TextArea placeholder="comment" className="mt-1 ps-4 py-2" rows={3} />
                            </Form.Item>
                        </div>
                        <div className='flex justify-center items-center gap-5 mt-5'>
                            <button type='button' onClick={() => setrequestAccept(false)} disabled={isLoading} className='bg-[#D91819] text-sm text-white font-medium uppercase px-10 py-2 rounded-lg hover:bg-[#aa0001] duration-500'>No</button>
                            <LoadableButton
                                type="Submit"
                                disabled={isReqLoading}
                                className='bg-[#2D9B63] text-sm text-white font-medium uppercase px-10 py-2 rounded-lg hover:bg-[#096034] duration-500'
                                lable='Yes'
                                isLoading={isReqLoading}
                                loadingLable='Accepting request...'
                            />
                        </div>
                    </Form>
                </>
            </ModalComponent>
        </div>
    )
}
